<template>
  <div>
    <div class="home">
      <div class="title">建设智慧医院，成为全国领先的物联网服务商</div>
      <div class="sub-title">多网融合的5G+物联网</div>
      <div class="content">
        <div class="show-item">
          <div class="show-image i1">
            <div class="only-center show-hover">
              <div>
                <div class="hover-title">医疗无线网络平台</div>
                <div class="hover-text">
                  当前，医疗数字经济时代已经来临，以信息技术和数据作为医疗行业发展的关键要素改革正蓬勃发展，并成为推动医疗服务升级、医院现代化建设的增效的主要力量。随着医院各种智能化系统的建立，对应系统的基站数量也增多，这就造成了院区内部多种无线网络无序建设，施工重复布线，互相之间信号干扰严重，信号经常出现丢包、漫游的情况，同时网络数据的安全无法得到有效保障，严重影响了医护的工作效率以及医院的信息安全，因此，医院需要
  一套更好的无线网络平台，诗为通过企业技术团队努力，为医院解决了这一问题

                </div>
              </div>
            </div>
          </div>
          <div class="only-center show-info">
            <div>
              <div class="info-title h" @click="jumptopage(1)">医疗无线网络平台</div>
              <div class="info-base info-btn info-width" @click="jumptopage(1)">可融合5G的物联网平台</div>
              <div class="info-base info-btn info-width" @click="jumptopage(7)">医疗定位网</div>
            </div>
          </div>
        </div>

        <div class="show-item">
          <div class="only-center show-info">
            <div>
              <div class="info-title">智慧病区</div>
              <div class="info-base info-btn" @click="jumptopage(2)">智能输液系统</div>
              <div class="info-base info-btn" @click="jumptopage(3)">智能体温监护系统</div>
              <div class="info-base info-btn" @click="jumptopage(10)">生命体征监护系统</div>
              <div class="info-base info-btn" @click="jumptopage(12)">医护对讲系统</div>
              <div class="info-base info-btn" @click="jumptopage(14)">远程探视系统</div>
              <div class="info-base info-btn" @click="jumptopage(8)">护理白板系统</div>
            </div>
          </div>
          <div class="show-image i2">
            <div class="only-center show-hover">
              <div>
                <div class="hover-title">智能输液系统</div>
                <div class="hover-text">
                  静脉输液是临床上最常用的治疗方法之一，通常包装在玻璃或塑料的输液瓶或袋中。使用时通过输液器调整滴速，持续而稳定地将药物输入体内。输液过程往往比较漫长，结束时需要及时处理换药或者拔针，如果处理不及时容易出现回血情况，无形中影响了患者休息，家属也需要时刻盯着输液袋，“家属陪护-呼叫打铃-护士被动服务”的现状，不可能一直延续下去。
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="show-item">
          <div class="show-image i3">
            <div class="only-center show-hover">
              <div>
                <div class="hover-title">婴儿防盗系统</div>
                <div class="hover-text">
                  医院新生儿安全至关重要，国内由于医院环境复杂，来往病房人员家属数量多，医院监管往往需要大量的人力物力，即使是日常管理严格，但是难免出现人员交接的空隙和安全隐患，新生儿被盗事件时有发生，在监管方面急需一款智能化技术解决方案，帮助医院建立科学有效的管理系统。
                </div>
              </div>
            </div>
          </div>
          <div class="only-center show-info">
            <div>
              <div class="info-title">智慧产科</div>
              <div class="info-base info-btn" @click="jumptopage(4)">婴儿防盗系统</div>
              <div class="info-base info-btn" @click="jumptopage(11)">医护报警系统</div>
              <div class="info-base info-btn" @click="jumptopage(6)">室内人员定位系统</div>
              <div class="info-base info-btn" @click="jumptopage(16)">院内导航系统</div>
              <div class="info-base info-btn" @click="jumptopage(5)">医院设备定位系统</div>
            </div>
          </div>
        </div>

        <div class="show-item">
          <div class="only-center show-info">
            <div>
              <div class="info-title">智慧管理</div>
              <div class="info-base info-btn" @click="jumptopage(9)">冷藏管理系统</div>
              <div class="info-base info-btn" @click="jumptopage(15)">院感管理系统</div>
              <div class="info-base info-btn" @click="jumptopage(13)">医疗废弃物管理系统</div>
              <div class="info-base info-btn" @click="jumptopage(17)">院内环境监控系统</div>
            </div>
          </div>
          <div class="show-image i4">
            <div class="only-center show-hover">
              <div>
                <div class="hover-title">医院设备定位系统</div>
                <div class="hover-text">
                  当前随着医院现代化建设不断深入，医院设备逐渐数量增多、价值高、分布分散，人工盘点费时费力，易出错，设备在各部门间流转并共用，设备位置、使用状态难以确认，经常出现找不到设备的情况，设备生命周期内的运转效率和能耗情况数据缺失，无法支撑设备的购买决策，设备维修保养缺乏电子化记录，维修人员不能及时找到有问题的设备，这些问题都困扰着医院的后勤管理，给医院增加了很多资金压力。
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>

    <div class="news-content">
      <div class="title">新闻资讯</div>
      <div class="sub-title">最新行业资讯</div>

      <div class="news-list" v-for="(item, index) in newsList" :key="index" @click="jumpDetail(item)">
        <div class="news-img" :style="`${item.indexImage ? `background-image: url(${item.indexImage});` :'background-image: url(/static/images/home_i1.png);'}`"></div>
          <div class="news-right">
            <div class="news-title">{{ item.title }}</div>
            <div class="news-sub-tit">
              发布时间：{{ item.publishTime }} &nbsp;来源：{{ item.author || '--' }} &nbsp; 浏览量：{{ item.pv }}
            </div>
            <div class="news-container" v-html="item.context"></div>
          </div>
      </div>

    </div>

    <div class="profile-width">
      <div class="profile-content">
        <div class="profile-text-tit">
          南京诗为信息科技有限公司
        </div>
        <div class="profile-content-text">
          <p>南京诗为成立于2019年12月，是专业从事医疗物联网和智能制造研究和开发的高新创新企业。公司拥有多款物联网产品及室内无线网络设备技术，总部设立在南京。南京诗为研发了全频段室内天馈系统，可以实现物联网平台及设备融合，服务医院项目，为国内医疗物联网领域注入新动力。</p>
          <p>随着公司技术的不断发展，南京诗为已经推出了一系列适用于临床、科室和日常医院管理的产品，包括智能输液系统、智能体温监护系统、婴儿防盗系统、医院设备定位系统、室内人员定位系统等。此外，公司还提供体征监护系统、医护对讲系统、远程探视系统、护理白板系统、冷藏管理系统、院感管理系统、医疗废弃物管理系统、院内环境监控系统、医护报警系统、室内人员定位系统、院内导航系统以及设备定位管理系统，进一步丰富产品线，满足医疗行业多样化的需求。</p>
          <p>这些产品和服务的集成，将进一步提升南京诗为在医疗物联网领域的竞争力，为医疗机构提供更加全面和高效的解决方案，助力医疗物联网行业的发展。</p>
        </div>
        <div class="profile-content-sub">
          业内领先物联网服务商
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getNewsList } from "../utils/api";
export default {
  name: 'home',
  // @ts-ignore
  metaInfo: {
    title: '南京诗为，业内领先的物联网服务商', // set a title
    meta: [
      {                 // set meta
        name: 'keyWords',
        content: '南京诗为,南京诗为信息科技,医院无线网络,医院无线网设备'
      },
      {
        name: 'description',
        content: '南京诗为,南京诗为信息科技,医院无线网络,医院无线网设备'
      }
    ]
  },
  data () {
    return {
      title: '',
      page: 1,
      total: 0,
      newsList: []
    }
  },
  methods:{
    jumptopage(type = 1){
      this.$router.push({ path: '/product', query: { type, t: Math.round(Math.random() * 10000) }})
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    // 获取新闻列表
    getList() {
      getNewsList({page: this.page, limit: 2,title: this.title, isShow: "1"}).then(res => {
        console.log(res, "--------------- news list1 ")
        if (res.code === 200 && res.data && res.data.list) {
          this.newsList = res.data.list;
          console.log(this.newsList, "--------------- news list2 ")
        }
      })
    },
    jumpDetail(item){
      sessionStorage.setItem("details", JSON.stringify(item));
      this.$router.push({ path: "/newsDetails", query: { id: item.id }})
    }
  },
  mounted() {
    this.getList();
  },
}
</script>

<style lang="scss" scoped>
.home{
  max-width: 850px;
  margin: 0 auto;
  color: #333;
  .only-center{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .title{
    padding: 30px 0 20px;
    line-height: 32px;
    text-align: center;
    font-size: 32px;
    font-weight: 600;
  }
  .sub-title{
    padding-bottom: 50px;
    line-height: 24px;
    font-size: 24px;
    text-align: center;
    color: #666;
  }
  .content{
    .show-item{
      height: 300px;
      display: flex;
      flex-wrap: nowrap;
      justify-content: space-between;
      margin-bottom: 15px;
      .show-image{
        width: 495px;
        position: relative;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;
        .show-hover{
          position: absolute;
          display: none;
          width: 100%;
          height: 100%;
          background-color: rgba(28,104,178,0.8);
          color: white;
          font-size: 14px;
          padding: 0 40px;
          transition: all 0.5s;
          user-select: none;
          .hover-title{
            font-size: 28px;
            margin-bottom: 10px;
          }
          .hover-text {
            line-height: 1.7;
          }
        }
        &.i1{ background-image: url(/static/images/home_i1.png); }
        &.i2{ background-image: url(/static/images/home_i2.png); }
        &.i3{ background-image: url(/static/images/home_i3.png); }
        &.i4{ background-image: url(/static/images/home_i4.png); }
        &:hover{
          .show-hover{
            display: flex;
          }
        }
      }
      .show-info{
        width: calc(100% - 510px);
        background-color: #e3e4e9;
        .info-title{
          text-align: center;
          font-size: 26px;
          font-weight: 600;
          letter-spacing: 2px;
          &.h{
            cursor: pointer;
            &:hover{
              color: #338BDB;
            }
          }
        }
        .info-base{
          font-size: 15px;
          text-align: center;
          color: #666;
          margin-top: 10px;
        }
        .info-btn{
          width: 145px;
          padding: 3px 0;
          border: 2px solid #bbb;
          border-radius: 6px;
          cursor: pointer;
          &:hover{
            background-color: #338BDB;
            color: white;
            border-color: #338BDB;
          }
        }
        .info-width {
          width: 224px;
        }
      }
    }
  }
  .profile{
    padding-bottom: 70px;
    .profile-title{
      text-align: center;
      font-size: 32px;
      font-weight: 600;
      letter-spacing: 2px;
      padding: 40px 0 10px;
    }
    .profile-sub-title{
      text-align: center;
      color: #666;
      font-size: 28px;
    }
    .profile-text-title{
      font-size: 24px;
      margin-top: 40px;
      padding: 20px 0 10px;
    }
    .profile-text{
      color: #666;
      p{
        letter-spacing: 1px;
        line-height: 28px;
        font-size: 18px;
        margin: 20px 0;
      }
    }
    .profile-image{
      height: 340px;
      background-image: url(/static/images/image_s.png);
      background-size: cover;
      background-repeat: no-repeat;
      background-position: center center;
    }
  }

}
.profile-width {
  background-image: url(/static/images/home_bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  width: 100%;
  height: 840px;
  padding-top: 50px;
  box-sizing: border-box;
}
.profile-content {
  width: 1250px;
  height: 710px;
  background: rgba(255, 255, 255, .8);
  margin: 0 auto;
  box-sizing: border-box;
  padding: 52px 190px;
}
.news-content {
  padding: 20px 0 20px;
  width: 1250px;
  margin: 0 auto;
  
  .title {
    text-align: center;
    font-size: 32px;
    font-weight: 600;
  }

  .sub-title {
    line-height: 24px;
    font-size: 22px;
    text-align: center;
    color: #666;
    letter-spacing: 4px;
    margin-top: 15px;
    margin-bottom: 30px;
  }

  .news-list {
    margin-top: 10px;
    height: 418px;
    border: 1px solid #ccc;
    background: #f3f3f3;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 30px;
    cursor: pointer;
  }
  .news-img {
    width: 700px;
    height: 416px;
    margin-right: 22px;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
  }

  .news-container {
    width: 550px;
    font-size: 16px;
    padding-right: 20px;
    text-align: justify;
    line-height: 2;
    color: #888;
    max-height: 310px;
    overflow: hidden;
  }

  .news-right {
    padding: 20px 0;

    .news-title {
      font-size: 25px;
      color: #555;
      font-weight: 600;
      
    }

    .news-sub-tit {
      font-size: 16px;
      padding: 8px 0;
      color: #888;
      margin-bottom: 2px;
      margin-top: 4px;
    }
  }

  
}
.profile-content-text {
  p {
    font-size: 18px;
    color: #666;
    line-height: 1.8;
    text-align: justify;
    padding-bottom: 35px;
  }
}
.profile-text-tit {
  padding-bottom: 30px;
  color: #333;
}
.profile-content-sub {
  padding-top: 30px;
  font-size: 30px;
  color: #777;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/pages/home.vue